import { useState } from "react";

import { Button } from "~/components/ui/button";

export function CopyButton({ value }: { value: string }) {
  const [status, setStatus] = useState<"idle" | "copied" | "failed">("idle");

  const handleClick = async () => {
    if (!navigator.clipboard?.writeText) {
      setStatus("failed");
      setTimeout(() => setStatus("idle"), 1500);
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      setStatus("copied");
    } catch {
      setStatus("failed");
    }
    setTimeout(() => setStatus("idle"), 1500);
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-6 px-2 text-xs"
      onClick={() => {
        void handleClick();
      }}
    >
      {status === "copied"
        ? "コピー済み"
        : status === "failed"
          ? "コピーできません"
          : "コピー"}
    </Button>
  );
}
